<template>
  <b-modal id="modal-standard" :title="nodeDialogTitle" title-class="font-18" centered hide-footer v-model="isVisible"
    scrollable @hide="closeNodeDialog()">

    <div ref="nodeDialog">
      <!-- Approval Node -->
      <div class="body" v-if="nodeForm.type === 'operation'">
        <label for="name">Désignation de la tâche</label>
        <input class="form-control" id="name" v-model="nodeForm.name"/><br>
        <label for="description">Description</label>
        <textarea cols="30" rows="3" class="form-control" v-model="nodeForm.description"></textarea><br>
        <label for="approver">Acteur</label>
        <select class="form-control" id="approver" :value="nodeForm.approver.id" @change="handleChangeApprover($event)">
          <option :value="item.id" :key="'approver-' + index" v-for="(item, index) in approvers">{{ item.name }}
          </option>
        </select>
      </div>
      <!-- Conditional Node -->
      <div class="body" v-if="nodeForm.type === 'condition'">
        <label for="type">Métadonnée</label>
        <select class="form-control" id="type" v-model="nodeForm.metadata" @change="onMetadataChange($event)">
          <option :key="'metadata-' + item.id" :value="item.id" v-for="item in metadatas">{{ item.label }}</option>
        </select><br>
        <label for="approver">Opérateur</label>
        <select class="form-control" id="operator" v-model="nodeForm.operator">
          <option :value="item.value" :key="'operator-' + item.value" v-for="item in operators">{{ item.name }}</option>
        </select><br>
        <label for="value">Valeur</label>
        <input type="text" class="form-control" v-model="nodeForm.value">
      </div>
      <div class="row">
        <div class="col-md-12">
          <button class="btn btn-primary mt-4 ml-2 mr-2" @click="handleClickSaveNode">Enregistrer</button>
          <button class="btn btn-light mt-4" @click="handleClickCancelSaveNode">Fermer</button>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import UserApi from "../../../api/userApi";
import MetadataApi from "../../../api/metadataApi";
export default {
  name: "NodeDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    node: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {
      nodeForm: {
        name: null,
        id: null,
        type: null,
        approver: [],
        metadata: null,
        operator: null,
        value: null,
        condition: null,
        description: null
      },
      nodeDialogStyle: {
        top: 0,
        left: 0,
      },
      metadataType: 'string',
      approvers: [],
      metadatas: [],
      operators: [
        {
          name: 'Egal (==)',
          value: '==',
        },
        {
          name: 'Différent (!=)',
          value: '!=',
        },
        {
          name: 'Supérieur (>)',
          value: '>',
        },
        {
          name: 'Supérieur ou Egal (>=)',
          value: '>=',
        },
        {
          name: 'Inférieur (<)',
          value: '<',
        },
        {
          name: 'Inférieur ou Egal (<=)',
          value: '<=',
        },
      ]
    };
  },
  computed: {
    isVisible: {
      get: function () {
        return this.visible;
      },
      set: function (newValue) {
        return newValue;
      }
    },
    nodeDialogTitle() {
      if (this.nodeForm.type === 'condition') {
        return "Gestion de la condition";
      }
      return "Gestion de la Tâche";
    }
  },
  methods: {
    closeNodeDialog() {
      this.$emit('closed');
    },
    handleClickSaveNode() {
      if (this.nodeForm.metadata != null && this.nodeForm.operator != null && this.nodeForm.value != null) {
        const metadataLabel = this.metadatas.filter((e) => e.id == this.nodeForm.metadata)[0].label;
        this.nodeForm.condition = `${metadataLabel} ${this.nodeForm.operator} ${this.nodeForm.value}`;
      }
      this.$emit(
        "update:node",
        Object.assign(this.node, {
          name: this.nodeForm.name,
          type: this.nodeForm.type,
          metadata: this.nodeForm.metadata,
          operator: this.nodeForm.operator,
          value: this.nodeForm.value,
          condition: this.nodeForm.condition,
          description: this.nodeForm.description,
          approvers: [Object.assign({}, this.nodeForm.approver)],
        })
      );
      this.$emit('closed');
    },
    handleClickCancelSaveNode() {
      this.$emit('closed');
    },
    handleChangeApprover(e) {
      console.log(e.target.value);
      
      this.nodeForm.approver = e.target.value!='' ? this.approvers.filter(
        (i) => i.id === parseInt(e.target.value)
      )[0] : null;
    },
    onMetadataChange(event) {
      /* eslint-disable no-console */
      const id = event.target.value;
      const metadata = this.metadatas.filter(e => e.id == id)[0];
      this.metadataType = metadata.type;
      // this.metadataType = e.type;
    },
  },
  watch: {
    node: {
      immediate: true,
      handler(val) {
        if (!val) {
          return;
        }
        this.nodeDialogStyle.top = `${ 0 } px`;
        this.nodeDialogStyle.left = `${ 0 } px`;
        this.nodeForm.id = val.id;
        this.nodeForm.name = val.name;
        this.nodeForm.type = val.type;
        this.nodeForm.metadata = val.metadata;
        this.nodeForm.operator = val.operator;
        this.nodeForm.value = val.value;
        if (val.approvers && val.approvers.length > 0) {
          this.nodeForm.approver = val.approvers[0];
        }
        this.nodeForm.description = val.description;
      },
    },
  },
  mounted() {
    UserApi.all().then((response) => {
      const users = response.data;
      this.approvers = users.map((user) => {
        const approver = {
          id: user.id,
          name: user.firstname+' '+user.lastname,
          url: user.picture_medium,
        };
        return approver;
      });
      this.approvers.unshift({
        id: 0,
        name: 'Acteur anonyme',
        url: 'user.jpg',
      })
    });

    MetadataApi.all().then((response) => {
      this.metadatas = response.data;
    });
  },
};
</script>

<style lang="scss" scoped>
.modal {
  box-shadow: 2px 2px 1px #d3d3d3;
  background-color: white;
  position: absolute; 
  display: inline;
  // top: 60px;
  // left: 0;
  height: 400px;
  width: 320px;
  padding-bottom: 10px;
  box-shadow: 0 1rem 3rem rgb(0 0 0 / 18%);
  border-radius: 6px;
  margin-left: auto;
  margin-right: auto;
  z-index: 20;
}

.body {
  padding: 10px;
}

.header {
  padding: 10px;
  border-bottom: 1px solid #d3d3d3;
}
</style>